import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const GET_DELIVERY_METHOD_I18N_CONFIG = gql`
    query GetDeliveryMethodI18nConfig {
        getDeliveryMethodI18nConfig {
            code
            zh
            en
            es
        }
    }
`;

export interface DeliveryMethodI18nItemType {
    code: string;
    zh: string;
    en: string;
    es: string;
}

export interface GetDeliveryMethodI18nConfigResponse {
    getDeliveryMethodI18nConfig: DeliveryMethodI18nItemType[];
}

export const getDeliveryMethodI18nConfig = async (): Promise<DeliveryMethodI18nItemType[]> => {
    const { data } = await client.query<GetDeliveryMethodI18nConfigResponse>({
        query: GET_DELIVERY_METHOD_I18N_CONFIG,
        fetchPolicy: 'cache-first'
    });
    return data?.getDeliveryMethodI18nConfig ?? [];
};
